<template>
  <header class="header">
    <Navigation :links="links" />
  </header>
</template>

<script>
import Navigation from './Navigation.vue';

export default {
  name: 'Header',
  components: {
    Navigation,
  },
  props: {
    links: Array,
  },
};
</script>

<style scoped lang="scss">
.header {

  h1 {
    width: 70%;
    margin-left: auto;
    margin-right: auto;

    @include bp(x) {
      width: 50%;
    }

    @include bp(s) {
      width: 100%;
    }
  }
}

h1 {
  font-size: 22px;
  text-transform: uppercase;
  text-align: center;
  color: $color-brand;
}
</style>
